import React from "react";
import Adminpage from "../components/admin/Adminpage";
import Headers from "../components/Header";
import Footer from "../components/Footer";
import Dashboardheader from "../components/Dashboardheader";
function AdminDashboard() {
    return (
        <>
            {/* <Headers /> */}
            <Dashboardheader />
            <Adminpage />
            <Footer />
        </>
    );
}

export default AdminDashboard;
